const SUPPORT_EMAIL = 'support@martcart.com';

interface NoAccessProps {
  email?: string;
  avatarInitials: string;
  /** Keeps sign-out and dark mode reachable, same avatar as Home */
  onToggleMenu: () => void;
}

/** Signed in, but no stores assigned (scope `none` or no customer link) */
export function NoAccess({ email, avatarInitials, onToggleMenu }: NoAccessProps) {
  return (
    <div className="flex h-full flex-col px-[18px] pb-10">
      <header className="mt-[26px] flex justify-end">
        <div
          onClick={onToggleMenu}
          className="flex h-[34px] w-[34px] cursor-pointer items-center justify-center rounded-full bg-chip text-xs font-bold text-chip-text"
        >
          {avatarInitials}
        </div>
      </header>
      <div className="flex flex-1 flex-col justify-center pb-16">
        <div className="rounded-card bg-card px-5 py-6 shadow-soft">
          <div className="mb-2 text-[19px] font-extrabold leading-tight text-ink">
            Your account isn't set up yet
          </div>
          <p className="mb-4 text-sm font-semibold leading-relaxed text-sub">
            {email ? (
              <>
                You're signed in as <span className="text-ink">{email}</span>, but no
                stores are assigned to your account.
              </>
            ) : (
              <>No stores are assigned to your account.</>
            )}{' '}
            Contact Martcart Zeosphere Support to be set up.
          </p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="text-sm font-bold text-ink underline underline-offset-2"
          >
            {SUPPORT_EMAIL}
          </a>
        </div>
      </div>
    </div>
  );
}
